export const BASE_PATH = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test" ? window.location.origin : "http://localhost:3000";
export const IMAGEKIT_URL_ENDPOINT = "https://ik.imagekit.io/elysiumone/";

/** @TODO STILL NEED TO UPDATE THEIR SUBSCRIPTION TIME & PLAN, some are YEARLY — TEMPORARY PREMIUM USER FIX, MIGHT NEED TO BE PRIVATE, BUT ALL IN ALL DOESN'T MATTER */
export const supporter_ids = [
  "60e158ea178a4e00152f6da2",
  "60f6e8c77cc43f0015746ed1",
  "60d08aaaa3f18400152fca93", // Zaccarias — he had a bad experience with ads, turned it off
  "60d21e765a148a0015d25e29", // Daniela T., subscribed
  "5ffadee41a6176001785c0a3", // Pauline — first official user, turned it off
  "609e51f7a601860015b41871", // Ness
  "60770f84b38f060015ae1b9e", // Barča, subscribed
  "60d95aba87cebb0015c0e51d", // Sun, had bad experience with badges
  "613566d2a1dc1300167140f6", // FM user trying out
  "61113d537614870015add100", // Elian subscribed!!!
  "6023639769a19e0015d0444a", // Charlotte
  "60cce4e47af6780015f1c6fa", // Terry
  "6101a1eabd93950015303061", // DJ subscribed
  "614dc7a5e3adff001684e1de", // Hazel
  "618f40c919b72d0016da6753", // Kristi
  "62559367eba11f001690c25e", // Kristoffer
  "61857f2910dce00016b1def0", // Nicole C.
  "6085944f03e8f50015c8baa5", // Charlotte C. subscribed
  "618fd1fe19b72d0016da681b", // Pardis K. had a slow experience after ads were up,
  "61e82bd2eb2e4b0016ce774c", // Lilly D. joined us
  "61db1ba82bbe340016112f1a", // Disabled ads for Dila who had issue w accessing site without VPN
  "61d70642705918001691da71", // Diba seems to be having issues joining sessions
  "60ed7045c30f370015468cf6", // Efi became a member
  "61fed8d12aa9af001637c696", // TikTokker
  "62093c8895282f0016915f56", // Ritta subscribed
  "62046a9fd17e7b0016dff2a0", // Mechelle subscribed
  "6268c7a4f6e7640016d0a968", // Philippa subscribed
  "609e505fa601860015b4186d", // Agnes subscribed
  "628036d16cd559001688939d", // Demo account for YC
  "6186bd0510dce00016b1e102", // Mia subscribed
  "62601460e4dac20016dfce55", // Mark subscribed
  "628b8c5dd1c5a300164de45b", // Sinem subscribed
  "626ab8595e610300169ab070", // Kas subscribed
  "62bcb6b30730390016daac7b", // Ashley subscribed
];
